import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ISearchAzureSavingsPlans,
  IAzureSavingsPlans,
} from '../../../services/azure/azureSavingsPlans/azureSavingsPlans.model';
import azureSavingsPlansService from '../../../services/azure/azureSavingsPlans/azureSavingsPlans.service';

// Asynchronous thunk action

export const searchAzureSavingsPlans = createAsyncThunk(
  'searchAzureSavingsPlans',
  async (searchParam?: ISearchAzureSavingsPlans) => {
    const response = await azureSavingsPlansService
      .searchAzureSavingsPlans(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getAzureSavingsPlansById = createAsyncThunk(
  'getAzureSavingsPlansById',
  async (id: number) => {
    const response = await azureSavingsPlansService.getAzureSavingsPlansById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveAzureSavingsPlans = createAsyncThunk(
  'saveAzureSavingsPlans',
  async (data: IAzureSavingsPlans) => {
    const response = await azureSavingsPlansService.saveAzureSavingsPlans(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteAzureSavingsPlans = createAsyncThunk(
  'deleteAzureSavingsPlans',
  async (id: number) => {
    const response = await azureSavingsPlansService.deleteAzureSavingsPlans(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
